const menuEn = {
    'menu.title': 'Fantasy Kingdom',
    'menu.startSandbox': 'Start Sandbox',
    'menu.tutorials': 'Tutorials',
    'menu.pickTutorial': 'Pick a tutorial',
    'menu.back': 'Back',
    'menu.quitTutorial': 'Quit tutorial',
    'menu.open': 'Menu',
};

export default menuEn;
